import { useState } from 'react'

export const useBooleanState = () => {
	const [active, setActive] = useState(false)

	const enable = () => setActive(true)

	const disable = () => setActive(false)

	const toggle = () => setActive(prev => !prev)

	return {
		active,
		enable,
		disable,
		toggle
	}
}
